export enum RouterNameEnum {
  LOGIN = 'Login',
  FEISHU_WORKBENCH = 'FeishuWorkbench',
  FEISHU_CALLBACK = 'FeishuCallback',
  SYSTEM = 'System',
  SUPPORT_APPLICATION = 'SupportApplication',
  SUPPORT_USER = 'SupportUser',
  DEFAULT_LAYOUT = 'DefaultLayout',
  HOME = 'Home',
  TRANSACTION_LIST = 'TransactionList',
  TRANSACTION_DETAIL = 'TransactionDetail',
  TRANSACTION = 'Transaction',
  BILL = 'BILL',
  BILL_DETAIL = 'BillDetail',
  ERROR = 'Error',
  NOT_FOUND = 'NotFound',
  SETTLE = 'Settle',
  MERCHANT_SETTLEMENT = 'merchantSettlement',
  CHARGEBACK = 'chargeback',
  QUOTE = 'quote',
  CURRENCY = 'currency',
  MERCHANT = 'merchant',
  MERCHANT_LIST = 'merchantList',
  MERCHANT_APP = 'merchantApp',
  MERCHANT_APP_STORE = 'merchantAppStore',
  MERCHANT_APP_STORE_DOMAIN = 'merchantAppStoreDomain',
  MERCHANT_APP_WEBHOOK = 'merchantAppWebhook',
  PAYMENT = 'Payment',
  Language = 'Language',
  USER_UPDATE = 'UserUpdate',
  ANALYSIS = 'analysis',
  PAYER = 'payer',
  SETTLE_MANAGE = 'SettleManage',
  DEMO = 'Demo',
  TEST = 'Test',
  REPLACE_PAYMENT = 'ReplacePayment',
  ACTIVITY = 'ACTIVITY',
  ACTIVITY_XY = 'ACTIVITY_XY',
  ACTIVITY_ADD_UP = 'ACTIVITY_ADD_UP',
  ACTIVITY_ADD_UP_REPLAY = 'ACTIVITY_ADD_UP_REPLAY',
  ACTIVITY_FIRST_BUY = 'ACTIVITY_FIRST_BUY',
  ACTIVITY_USER_FIRST_BUY = 'ACTIVITY_USER_FIRST_BUY',
  ACTIVITY_LIMIT = 'ACTIVITY_LIMIT',
  RECHARGE_HISTORY = 'RECHARGE_HISTORY',
  FINANCE = 'Finance',
  WITHDRAW_CASH = 'WITHDRAW_CASH',
  ACTIVITY_RECHARGE = 'ACTIVITY_RECHARGE',
  ACTIVITY_SIGN = 'ACTIVITY_SIGN',
  ACTIVITY_SIGN_REPLAY = 'ACTIVITY_SIGN_REPLAY',
  ACTIVITY_CONSECUTIVE = 'ACTIVITY_CONSECUTIVE',
  ACTIVITY_CONSECUTIVE_REPLAY = 'ACTIVITY_CONSECUTIVE_REPLAY',
  ACTIVITY_LOTTERY = 'ACTIVITY_LOTTERY',
  ACTIVITY_LOTTERY_REPLAY = 'ACTIVITY_LOTTERY_REPLAY',
  ACTIVITY_CONVERT_KEY = 'ACTIVITY_CONVERT_KEY',
  ACTIVITY_FULL_DISCOUNT = 'ACTIVITY_FULL_DISCOUNT',
  ACTIVITY_INVITE_CODE = 'ACTIVITY_INVITE_CODE',
  VIP = 'VIP',
  VIP_RANK = 'VIP_RANK',
  VIP_BENEFIT = 'VIP_BENEFIT',
  VIP_POINTS = 'VIP_POINTS',
  VIP_CONFIG = 'VIP_CONFIG',
  VIP_APP = 'VIP_APP',
  ORDER_PURCHASE_HISTORY = 'ORDER_PURCHASE_HISTORY',
  /** 交易对账对比表（原币口径） */
  RECONCILIATION_TABLE = 'ReconciliationTable',
  VIP_GLOBAL = 'VIP_GLOBAL',
  STREAM = 'STREAM',
  CONVERSION = 'CONVERSION',
  RANK = 'RANK',
  VISITS = 'VISITS',
  PWA = 'PWA',
  /** 商品 */
  GOODS = 'Goods',
  GOODS_MANAGE = 'GoodsManage',
  GOODS_CATEGORY = 'GoodsCategory',
  GOODS_CURRENCY = 'GoodsCurrency',
  GOODS_MONTH_CARD = 'GoodsMonthCard',
  GOODS_RECHARGE = 'GoodsRecharge',
  GOODS_PROPS_LIBRARY = 'GoodsPropsLibrary',
  /** 服务市场 */
  SERVICE_MARKET = 'ServiceMarket',
  /** 商户视角 */
  MERCHANT_CONSOLE = 'MerchantConsole',
  /** 商户入驻审核 */
  KYB_AUDIT = 'KybAudit',
}
